import { FC, useState } from 'react'
import { Save, Download, Upload, Settings, Image } from 'lucide-react'

interface HeaderProps {
  projectName: string
  onProjectNameChange: (name: string) => void
  onSetBackgroundImage: () => void
  onSave: () => void
  onLoad: () => void
}

const Header: FC<HeaderProps> = ({ projectName, onProjectNameChange, onSetBackgroundImage, onSave, onLoad }) => {
  const [isEditing, setIsEditing] = useState(false)

  const handleExport = () => {
    // TODO: PDF出力
    alert('PDF出力機能は実装予定')
  }

  return (
    <header className="bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-between">
      {/* プロジェクト名 */}
      <div className="flex items-center gap-4">
        <h1 className="text-xl font-bold text-gray-800">
          {isEditing ? (
            <input
              type="text"
              value={projectName}
              onChange={(e) => onProjectNameChange(e.target.value)}
              onBlur={() => setIsEditing(false)}
              onKeyDown={(e) => e.key === 'Enter' && setIsEditing(false)}
              className="border border-gray-300 rounded px-2 py-1"
              autoFocus
            />
          ) : (
            <span
              onClick={() => setIsEditing(true)}
              className="cursor-pointer hover:text-primary-600"
            >
              {projectName}
            </span>
          )}
        </h1>
      </div>

      {/* 操作ボタン */}
      <div className="flex items-center gap-3">
        <button
          onClick={onSetBackgroundImage}
          className="flex items-center gap-2 px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700 transition"
        >
          <Image size={18} />
          背景画像
        </button>

        <button
          onClick={onSave}
          className="flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded hover:bg-primary-700 transition"
        >
          <Save size={18} />
          保存
        </button>
        
        <button
          onClick={handleExport}
          className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition"
        >
          <Download size={18} />
          PDF出力
        </button>
        
        <button
          onClick={onLoad}
          className="flex items-center gap-2 px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 transition"
        >
          <Upload size={18} />
          読込
        </button>
        
        <button className="p-2 hover:bg-gray-100 rounded transition">
          <Settings size={20} className="text-gray-600" />
        </button>
      </div>
    </header>
  )
}

export default Header
